import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"
import { PageHeader } from "../../../../../../../shared/components/pageHeader/PageHeader"
import { Page } from "../../../../../../../shared/components/pageHeader/PageHeaderApi"
import {
    Breadcrumb,
    BreadcrumbLink,
    StandardBreadcrumbs,
} from "../../../../../../../shared/components/links/StandardBreadcrumbs"
import { getRefillWalletRoute, USER_REPORTS_ROUTE } from "../../../../../../../constants/routes"
import { Box } from "@mui/system"
import { useApiQuery } from "../../../../../../../core/api/useApiQuery"
import { Stack, Typography } from "@mui/material"
import { StandardChip } from "../../../../../../../shared/components/badges/StandardChip"
import { toDinero } from "../../../../../../currency/currencyLib"
import { makeStyles } from "tss-react/mui"
import { useMoney } from "../../../../../../currency/useMoney"
import { tailwindPalette } from "../../../../../../theme/tailwindPalette"
import { useNavigate } from "react-router"
import { fetchUserWallets, FetchUserWalletsResponse, WalletsRefill } from "../../refill/refillApi"
import { useAppSelector } from "../../../../../../store/storeHooks"
import { selectEffectiveUserId } from "../../../../../../context/contextSelectors"
import { UserWalletsRefillState } from "../../refill/pages/UserWalletsRefill"
import { UserWallet } from "../../refill/refillTypes"

const transformData = (data: FetchUserWalletsResponse) => {
    return data.wallets || []
}

const useStyles = makeStyles()(() => ({
    title: {
        marginTop: "-3rem",
        paddingBottom: "1rem",
        textAlign: "center",
    },
    card: {
        padding: "1rem",
        cursor: "pointer",
        width: "16rem",
        height: "9rem",
        borderRadius: ".5rem",
        backgroundColor: tailwindPalette.blue[600],
    },
}))

export function UserWallets() {
    const { classes } = useStyles()
    const moneyFactory = useMoney({})
    const navigate = useNavigate()

    const userId = useAppSelector(selectEffectiveUserId) || 0

    const { data: userWallets } = useApiQuery(fetchUserWallets, {
        queryName: WalletsRefill.USER_WALLETS,
        dependencies: {
            userId,
        },
        select: transformData,
    })

    const selectWallet = (wallet: UserWallet) => {
        const state: UserWalletsRefillState = {
            wallet,
        }
        navigate(getRefillWalletRoute(wallet.acquirer.acquirerSetupId, wallet.id), { state })
    }

    return (
        <>
            <LocalizedStrict id="user-settings-wallets-title" attrs={{ title: true }}>
                <PageHeader page={Page.USER_SETTINGS_WALLETS} title="Wallets">
                    <StandardBreadcrumbs>
                        <LocalizedStrict id="user-nav-item-home">
                            <BreadcrumbLink to={USER_REPORTS_ROUTE}>Home</BreadcrumbLink>
                        </LocalizedStrict>

                        <LocalizedStrict id="user-nav-item-settings">
                            <Breadcrumb>Settings</Breadcrumb>
                        </LocalizedStrict>

                        <LocalizedStrict id="user-nav-item-wallets">
                            <Breadcrumb>Wallets</Breadcrumb>
                        </LocalizedStrict>
                    </StandardBreadcrumbs>
                </PageHeader>
            </LocalizedStrict>

            <Stack direction="row" spacing="2rem">
                {userWallets?.map((wallet) => (
                    <Box
                        key={wallet.id}
                        onClick={() => selectWallet(wallet)}
                        className={classes.card}
                    >
                        <Stack direction="column" spacing=".75rem">
                            {wallet.statusLabel && (
                                <Box display="flex" justifyContent="end">
                                    <StandardChip variant="white-outline">{wallet.statusLabel}</StandardChip>
                                </Box>
                            )}
                            <Typography variant="h5" color="white">
                                {moneyFactory.format(toDinero(wallet.balance))}
                            </Typography>
                            <Typography variant="body2" color="white">
                                {wallet.brandingLabel}
                            </Typography>
                        </Stack>
                    </Box>
                ))}
            </Stack>
        </>
    )
}
